<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1>لیست تخفیف های کلاس</h1>
          <div class="mt-2">
            <b-button
              variant="success"
              class="mr-2"
              @click="renderCreateDiscountModal"
            >
              ایجاد تخفیف جدید
            </b-button>
            <b-button variant="primary" @click="renderCreateCouponModal">
              ایجاد کوپن جدید
            </b-button>
          </div>
          <h2 class="mt-4">تخفیف ها</h2>
          <hr />
          <div class="my-2">
            <!-- Table Top Start -->
            <b-row>
              <!-- Search -->
              <b-col cols="12" md="6">
                <b-form-group label="از تاریخ" label-for="discountFromDate">
                  <b-form-input
                    class="discountFromDate"
                    id="discountFromDate"
                    placeholder="تاریخ شروع تخفیف را وارد کنید"
                  ></b-form-input>
                  <date-picker
                    v-model="discountFromDate"
                    class="absolute"
                    customInput=".discountFromDate"
                    display-format="jYYYY/jMM/jDD"
                    input-format="jYYYY/jMM/jDD"
                    format="YYYY-MM-DD"
                  ></date-picker>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="تا تاریخ" label-for="discountToDate">
                  <b-form-input
                    class="discountToDate"
                    id="discountToDate"
                    placeholder="تاریخ پایان تخفیف را وارد کنید"
                  ></b-form-input>
                  <date-picker
                    v-model="discountToDate"
                    class="absolute"
                    customInput=".discountToDate"
                    display-format="jYYYY/jMM/jDD"
                    input-format="jYYYY/jMM/jDD"
                    format="YYYY-MM-DD"
                  ></date-picker>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- Table Top End -->
          </div>
          <b-table
            ref="refUserListTable"
            class="position-relative mt-2"
            :items="discountList"
            responsive
            :fields="discountTableCols"
            primary-key="discountId"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <template #cell(type)="data">
              {{ discountTypesEnum[data.item.type] }}
            </template>
            <template #cell(value)="data">
              <template v-if="data.item.type == 1">
                {{ Intl.NumberFormat("en-US").format(data.item.value) }} تومان
              </template>
              <template v-else>{{ data.item.value }}%</template>
            </template>
            <template #cell(lessonTitle)="data">
              <b-link :to="`/lessons/${data.item.lessonId}`">
                {{ data.item.lessonTitle }}
              </b-link>
            </template>
            <template #cell(startDate)="data">
              {{ new Date(data.item.startDate).toLocaleDateString("fa-IR") }}
            </template>
            <template #cell(expireDate)="data">
              {{ new Date(data.item.expireDate).toLocaleDateString("fa-IR") }}
            </template>
          </b-table>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-center py-2"
          >
            <b-pagination
              v-model="discountPageNumber"
              :total-rows="discountTotalCount"
              :per-page="discountCount"
              first-number
              last-number
              class="mb-0 mt-1"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>

          <h2 class="mt-4">کوپن ها</h2>
          <hr />
          <b-table
            ref="refUserListTable"
            class="position-relative mt-2"
            :items="couponList"
            responsive
            :fields="couponTableCols"
            primary-key="discountId"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <template #cell(type)="data">
              {{ couponTypesEnum[data.item.type] }}
            </template>
            <template #cell(couponValue)="data">
              <template v-if="data.item.type == 2">
                {{ Intl.NumberFormat("en-US").format(data.item.couponValue) }}
                تومان
              </template>
              <template v-else>{{ data.item.couponValue }}%</template>
            </template>
            <template #cell(baseQuantity)="data">
              <template v-if="data.item.baseQuantity">
                {{ data.item.baseQuantity }}
              </template>
              <template v-else> بدون سقف استفاده </template>
            </template>
            <template #cell(lessonTitle)="data">
              <b-link :to="`/lessons/${data.item.lessonId}`">
                {{ data.item.lessonTitle }}
              </b-link>
            </template>
            <template #cell(startDate)="data">
              {{ new Date(data.item.startDate).toLocaleDateString("fa-IR") }}
            </template>
            <template #cell(endDate)="data">
              {{ new Date(data.item.endDate).toLocaleDateString("fa-IR") }}
            </template>
          </b-table>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-center py-2"
          >
            <b-pagination
              v-model="couponPageNumber"
              :total-rows="couponTotalCount"
              :per-page="couponCount"
              first-number
              last-number
              class="mb-0 mt-1"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
    <create-discount-modal
      :discountFor="'lesson'"
      @reFetch="getAllDiscounts"
    ></create-discount-modal>
    <create-coupon-modal :discountFor="'lesson'"></create-coupon-modal>
  </b-overlay>
</template>
<script>
import CreateDiscountModal from "@/views/components/Offers/CreateDiscountModal.vue";
import CreateCouponModal from "@/views/components/Offers/CreateCouponModal.vue";
import { GetAllDiscounts } from "@/libs/Api/Discount";
import { GetAllCoupons } from "@/libs/Api/Coupon";
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BModal,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
export default {
  watch: {
    discountFromDate: {
      handler(val) {
        this.getAllDiscounts();
      },
    },
    discountToDate: {
      handler(val) {
        this.getAllDiscounts();
      },
    },
  },
  mounted() {
    this.getAllDiscounts();
    this.getAllCoupons();
  },
  data() {
    return {
      isLoading: false,
      discountCount: 10,
      discountPageNumber: 1,
      discountTotalCount: null,
      discountFromDate: null,
      discountToDate: null,
      discountList: null,
      discountTypesEnum: {
        1: "مبلغ",
        2: "درصد",
      },
      couponTypesEnum: {
        1: "درصد",
        2: "مبلغ",
      },
      discountTableCols: [
        {
          key: "discountId",
          label: "شناسه تخفیف",
        },
        {
          key: "type",
          label: "نوع تخفیف",
        },
        {
          key: "value",
          label: "مقدار تخفیف",
        },
        {
          key: "startDate",
          label: "تاریخ شروع",
        },
        {
          key: "expireDate",
          label: "تاریخ پایان",
        },
        {
          key: "lessonTitle",
          label: "نام درس",
        },
      ],
      couponTableCols: [
        {
          key: "couponId",
          label: "شناسه کوپن",
        },
        {
          key: "type",
          label: "نوع کوپن",
        },
        {
          key: "couponValue",
          label: "مقدار تخفیف",
        },
        {
          key: "startDate",
          label: "تاریخ شروع",
        },
        {
          key: "endDate",
          label: "تاریخ پایان",
        },
        {
          key: "code",
          label: "کد کوپن",
        },
        {
          key: "baseQuantity",
          label: "تعداد قابل استفاده از کوپن",
        },
      ],
      couponCount: 10,
      couponPageNumber: 1,
      couponTotalCount: null,
      couponLessonId: null,
      couponUserId: null,
      couponList: null,
    };
  },
  methods: {
    renderCreateDiscountModal() {
      this.$bvModal.show("modal-discount-add");
    },
    renderCreateCouponModal() {
      this.$bvModal.show("modal-coupon-add");
    },
    async getAllCoupons() {
      try {
        this.isLoading = false;
        let _this = this;
        let getAllCoupons = new GetAllCoupons(_this);
        let qParams = {
          count: _this.couponCount,
          pageNumber: _this.couponPageNumber,
        };
        if (this.couponLessonId) {
          qParams["lessonId"] = _this.couponLessonId;
        }
        getAllCoupons.setRequestParam(qParams);
        await getAllCoupons.fetch((response) => {
          _this.couponList = response.coupons;
          _this.couponTotalCount = response.couponsCount;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllDiscounts() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllDiscounts = new GetAllDiscounts(_this);
        let qParams = {
          count: _this.discountCount,
          pageNumber: _this.discountPageNumber,
          searchType: 2,
        };
        if (this.discountFromDate) {
          qParams["discountFromDate"] = this.discountFromDate;
        }
        if (this.discountToDate) {
          qParams["discountToDate"] = this.discountToDate;
        }
        getAllDiscounts.setRequestParam(qParams);
        await getAllDiscounts.fetch((response) => {
          if (response.isSuccess) {
            _this.discountTotalCount = response.data.discountsCount;
            _this.discountList = response.data.discounts;
          }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CreateDiscountModal,
    CreateCouponModal,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BModal,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
</script>
